import CryptoJS from "crypto-js"

let APPID = "5f1fe284"
let API_SECRET = "3967192b4df049024bd87360749f0f8a"
let API_KEY = "9a06cf1d7d646453f682c5871dd3f768"

// TODO: appId,api_secret,api_key改为后端获取进行保密
export default class IatRecorder {
    constructor({language, accent, asrConfig, onWillStatusChange, onTextChange, onInitError} = {}) {
        this.status = "null"
        this.language = language || "zh_cn"
        this.accent = accent || "mandarin"
        this.appId = (asrConfig && asrConfig.appId) || APPID
        this.onWillStatusChange = onWillStatusChange
        this.onTextChange = onTextChange
        this.onInitError = onInitError

        // 保存服务器连接信息
        this.asrConfig = asrConfig

        // 记录音频数据
        this.audioData = []
        // 记录听写结果
        this.resultText = ""
        // wpgs下的听写结果需要中间状态辅助记录
        this.resultTextTemp = ""
    }

    destory() {
        this.onWillStatusChange = null
        this.onTextChange = null
        this.onInitError = null
    }

    getWebSocketUrl() {
        if (this.asrConfig != null) {
            // console.log("使用了服务器的语音解析地址", this.asrConfig.url)
            return new Promise((resolve) => {
                resolve(this.asrConfig.url)
            })
        } else {
            return new Promise((resolve) => {
                // 请求地址根据语种不同变化
                let url = "wss://iat-api.xfyun.cn/v2/iat"
                let host = "iat-api.xfyun.cn"
                let apiKey = API_KEY
                let apiSecret = API_SECRET
                let date = new Date().toGMTString()
                let algorithm = "hmac-sha256"
                let headers = "host date request-line"
                let signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`
                let signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
                let signature = CryptoJS.enc.Base64.stringify(signatureSha)
                let authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
                let authorization = btoa(authorizationOrigin)
                url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
                resolve(url)
            })
        }
    }

    // 修改录音听写状态
    setStatus(status) {
        this.onWillStatusChange && this.status !== status && this.onWillStatusChange(this.status, status)
        this.status = status
    }

    setResultText({resultText, resultTextTemp} = {}) {
        this.onTextChange && this.onTextChange(resultTextTemp || resultText || "")
        resultText !== undefined && (this.resultText = resultText)
        resultTextTemp !== undefined && (this.resultTextTemp = resultTextTemp)
    }

    transcode(audioData) {
        let output = this.to16kHz(audioData)
        output = this.to16BitPCM(output)
        output = Array.from(new Uint8Array(output.buffer))
        this.audioData.push(...output)
    }

    to16kHz(audioData) {
        let data = new Float32Array(audioData)
        let fitCount = Math.round(data.length * (16000 / 44100))
        let newData = new Float32Array(fitCount)
        let springFactor = (data.length - 1) / (fitCount - 1)
        newData[0] = data[0]
        for (let i = 1; i < fitCount - 1; i++) {
            let tmp = i * springFactor
            let before = Math.floor(tmp).toFixed()
            let after = Math.ceil(tmp).toFixed()
            let atPoint = tmp - before
            newData[i] = data[before] + (data[after] - data[before]) * atPoint
        }
        newData[fitCount - 1] = data[data.length - 1]
        return newData
    }

    to16BitPCM(input) {
        let dataLength = input.length * (16 / 8)
        let dataBuffer = new ArrayBuffer(dataLength)
        let dataView = new DataView(dataBuffer)
        let offset = 0
        for (let i = 0; i < input.length; i++, offset += 2) {
            let s = Math.max(-1, Math.min(1, input[i]))
            dataView.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true)
        }
        return dataView
    }

    // 修改听写参数
    setParams({language, accent} = {}) {
        language && (this.language = language)
        accent && (this.accent = accent)
    }

    // 连接websocket
    connectWebSocket() {
        return this.getWebSocketUrl().then((url) => {
            let iatWS

            if ("WebSocket" in window) {
                iatWS = new WebSocket(url)
            } else if ("MozWebSocket" in window) {
                iatWS = new MozWebSocket(url)
            } else {
                this.onInitError(new Error("当前浏览器不支持语音输入功能"))
                return
            }

            this.webSocket = iatWS
            this.setStatus("init")
            iatWS.onopen = (e) => {
                // console.log("onOpen", e)
                this.setStatus("ing")
                // 重新开始录音
                setTimeout(() => {
                    this.webSocketSend()
                }, 500)
            }
            iatWS.onmessage = (e) => {
                // console.log("onMessage", e)
                this.result(e.data)
            }
            iatWS.onerror = (e) => {
                // console.log("onError", e)
                this.onInitError(new Error("当前网络异常，请稍后再试"))
                this.recorderStop()
            }
            iatWS.onclose = (e) => {
                // console.log("onclose", e)
                this.recorderStop()
            }
        })
    }

    // 初始化浏览器录音
    recorderInit() {
        navigator.getUserMedia =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia

        // 创建音频环境
        try {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
            this.audioContext.resume()
            if (!this.audioContext) {
                this.onInitError && this.onInitError(new Error("浏览器不支持webAudioApi相关接口"))
                return
            }
        } catch (e) {
            if (!this.audioContext) {
                this.onInitError && this.onInitError(new Error("浏览器不支持webAudioApi相关接口"))
                return
            }
            console.error("创建音频环境失败")
        }

        // 获取浏览器录音权限
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices
                .getUserMedia({
                    audio: true,
                    video: false,
                })
                .then((stream) => {
                    getMediaSuccess(stream)
                })
                .catch((e) => {
                    getMediaFail(e)
                })
        } else if (navigator.getUserMedia) {
            navigator.getUserMedia(
                {
                    audio: true,
                    video: false,
                },
                (stream) => {
                    getMediaSuccess(stream)
                },
                (e) => {
                    getMediaFail(e)
                }
            )
        } else {
            if (navigator.userAgent.toLowerCase().match(/chrome/) && location.origin.indexOf("https://") < 0) {
                this.onInitError && this.onInitError(new Error("当前网址不支持语音输入功能"))
            } else {
                this.onInitError && this.onInitError(new Error("无法获取浏览器录音功能，请升级浏览器或使用chrome"))
            }
            this.audioContext && this.audioContext.close()
            return
        }

        // 获取浏览器录音权限成功的回调
        let getMediaSuccess = (stream) => {
            // console.log("getMediaSuccess")
            // 创建一个用于通过JavaScript直接处理音频

            this.stream = stream

            this.scriptProcessor = this.audioContext.createScriptProcessor(0, 1, 1)
            this.scriptProcessor.onaudioprocess = (e) => {
                // 去处理音频数据
                if (this.status === "ing") {
                    // this.transWorker.postMessage(e.inputBuffer.getChannelData(0));
                    this.transcode(e.inputBuffer.getChannelData(0))
                }
            }
            // 创建一个新的MediaStreamAudioSourceNode 对象，使来自MediaStream的音频可以被播放和操作
            this.mediaSource = this.audioContext.createMediaStreamSource(stream)
            // 连接
            this.mediaSource.connect(this.scriptProcessor)
            this.scriptProcessor.connect(this.audioContext.destination)
            this.connectWebSocket()
        }

        let getMediaFail = (e) => {
            this.onInitError && this.onInitError(e)
            this.audioContext && this.audioContext.close()
            this.audioContext = undefined
            // 关闭websocket
            if (this.webSocket && this.webSocket.readyState === 1) {
                this.webSocket.close()
            }
        }
    }

    recorderStart() {
        this.recorderInit()
    }

    // 暂停录音
    recorderStop() {
        this.audioContext && this.audioContext.close()
        this.audioContext = undefined

        // this.audioContext && this.audioContext.suspend()
        // safari下suspend后再次resume录音内容将是空白，设置safari下不做suspend
        // if (!(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgen))) {
        // }

        this.setStatus("end")
        this.webSocket && this.webSocket.close()
        this.stream.getTracks()[0].stop()
    }

    // 处理音频数据
    // transAudioData(audioData) {
    //   audioData = transAudioData.transaction(audioData)
    //   this.audioData.push(...audioData)
    // }
    // 对处理后的音频数据进行base64编码，
    toBase64(buffer) {
        let binary = ""
        let bytes = new Uint8Array(buffer)
        let len = bytes.byteLength
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i])
        }
        return window.btoa(binary)
    }

    // 向webSocket发送数据
    webSocketSend() {
        if (this.webSocket.readyState !== 1) {
            return
        }
        let audioData = this.audioData.splice(0, 1280)
        let params = {
            common: {
                app_id: this.appId,
            },
            business: {
                language: this.language, // 小语种可在控制台--语音听写（流式）--方言/语种处添加试用
                domain: "iat",
                accent: this.accent, // 中文方言可在控制台--语音听写（流式）--方言/语种处添加试用
                vad_eos: 5000,
                dwa: "wpgs", // 为使该功能生效，需到控制台开通动态修正功能（该功能免费）
            },
            data: {
                status: 0,
                format: "audio/L16;rate=16000",
                encoding: "raw",
                audio: this.toBase64(audioData),
            },
        }
        this.webSocket.send(JSON.stringify(params))
        this.handlerInterval = setInterval(() => {
            // websocket未连接
            if (this.webSocket.readyState !== 1) {
                this.audioData = []
                clearInterval(this.handlerInterval)
                return
            }
            if (this.audioData.length === 0) {
                if (this.status === "end") {
                    this.webSocket.send(
                        JSON.stringify({
                            data: {
                                status: 2,
                                format: "audio/L16;rate=16000",
                                encoding: "raw",
                                audio: "",
                            },
                        })
                    )
                    this.audioData = []
                    clearInterval(this.handlerInterval)
                }
                return false
            }
            audioData = this.audioData.splice(0, 1280)
            // 中间帧
            this.webSocket.send(
                JSON.stringify({
                    data: {
                        status: 1,
                        format: "audio/L16;rate=16000",
                        encoding: "raw",
                        audio: this.toBase64(audioData),
                    },
                })
            )
        }, 40)
    }

    result(resultData) {
        // 识别结束
        let jsonData = JSON.parse(resultData)
        // console.log(jsonData)
        if (jsonData.data && jsonData.data.result) {
            let data = jsonData.data.result
            let str = ""
            let resultStr = ""
            let ws = data.ws
            for (let i = 0; i < ws.length; i++) {
                str = str + ws[i].cw[0].w
            }
            // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
            // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
            if (data.pgs) {
                if (data.pgs === "apd") {
                    // 将resultTextTemp同步给resultText
                    this.setResultText({
                        resultText: this.resultTextTemp,
                    })
                }
                // 将结果存储在resultTextTemp中
                this.setResultText({
                    resultTextTemp: this.resultText + str,
                })
            } else {
                this.setResultText({
                    resultText: this.resultText + str,
                })
            }
        }
        if (jsonData.code === 0 && jsonData.data.status === 2) {
            this.webSocket.close()
        }
        if (jsonData.code !== 0) {
            // 此处为流量错误
            this.onInitError && this.onInitError(new Error("当前网络异常，请稍后再试"))
            this.webSocket.close()
            // console.log(`${jsonData.code}:${jsonData.message}`)
        }
    }

    start() {
        console.log("start")
        this.recorderStart()
        this.setResultText({resultText: "", resultTextTemp: ""})
    }

    stop() {
        this.recorderStop()
    }
}
